export default {
  text: 'Este restaurante está suspenso. Por favor contacte o seu responsável ou envie-nos uma mensagem para <a>{{supportEmail}}</a> se pretender restaurá-lo',
};
